import React from "react";
import successCoupon from "../../../../assets/images/couponsuccess.png";
import Header from "../../../Layout/Header";
import "./couponsuccess.scss";
const CouponSuccess = () => {
  return (
    <>
      <Header name={"العروض والكوبونات"} />
      <div className=" mx-auto xl:w-[1209px] my-8  p-8 coupon-success">
        <div className="flex justify-center lg:pt-[72px] ">
          <img src={successCoupon} alt="" />
        </div>
        <h1 className="text-[32px] text-center font-extrabold  mt-[70px] lg:mb-[180px]">
          تم ارسال الكوبون الى بريدك الإلكتروني بنجاح
        </h1>
        <div className="flex justify-between ">
          <div className="flex">
            <img src="" alt="" />
            <p>Lorem ipsum dolor sit.</p>
          </div>
          <div>
            <p>متبقي 5 ايام</p>
            <p>تاريخ الانتهاء 2024-3-25</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CouponSuccess;
